/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";
import React from "react";

const SingleSection = styled(({ ...props }) => (
  <Grid
    {...props}
    container
    direction="column"
    alignItems="stretch"
    spacing={3}
    xs={12}
  />
))`
  ${({ theme }) => `  
    ${theme.breakpoints.up("xs")} {
      position: relative;
      padding: ${theme.spacing(4)}px ${theme.spacing(2)}px;
    }
  `}
`;

export default SingleSection;
